import { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { ActionResultOptions, CustomSelect, HTTPMethodOptions } from "../../../../../../_helpers/Helpers";
import { useUserLogsUIContext } from "../UserLogsUIContext";

const prepareFilter = (queryParams, values) => {
  let { schoolName, userName, path, actionTime, method, isSuccess } = values;
  const newQueryParams = { ...queryParams };
  const filter = { schoolName, userName, path, actionTime, method, isSuccess };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function UserLogsFilter() {
  // User Logs UI Context
  const userLogsUIContext = useUserLogsUIContext();
  const userLogsUIProps = useMemo(() => {
    return {
      queryParams: userLogsUIContext.queryParams,
      setQueryParams: userLogsUIContext.setQueryParams
    };
  }, [userLogsUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(userLogsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, userLogsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      userLogsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        schoolName: "",
        userName: "",
        path: "",
        actionTime: "",
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="schoolName"
                placeholder="Okul Adı"
                onBlur={handleBlur}
                value={values.schoolName}
                onChange={(e) => {
                  setFieldValue("schoolName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Okul Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="userName"
                placeholder="Kullanıcı Adı"
                onBlur={handleBlur}
                value={values.userName}
                onChange={(e) => {
                  setFieldValue("userName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kullanıcı Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="path"
                placeholder="Path"
                onBlur={handleBlur}
                value={values.path}
                onChange={(e) => {
                  setFieldValue("path", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Path</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="actionTime"
                placeholder="Tarih"
                onBlur={handleBlur}
                value={values.actionTime}
                onChange={(e) => {
                  setFieldValue("actionTime", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Tarih</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={HTTPMethodOptions}
                value={values.method}
                placeholder="Metod"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("method", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Metod</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={ActionResultOptions}
                value={values.isSuccess}
                placeholder="Sonuç"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("isSuccess", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sonuç</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}